import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"transmission_title"} defaultMessage={"Transmissão"}/></b></p></h5>
            </div>
            <div align="center" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"transmission_text_1"} defaultMessage={"Aperto de mãos"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_2"} defaultMessage={"Gotas de saliva"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_3"} defaultMessage={"Tosse"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_4"} defaultMessage={"Espirro"}/></li>
                </ul>
                <b><FormattedMessage id={"transmission_text_5"} defaultMessage={"Objetos contaminados como:"}/></b>
                <ul>
                    <li>• <FormattedMessage id={"transmission_text_6"} defaultMessage={"Celulares"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_7"} defaultMessage={"Mesas"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_8"} defaultMessage={"Maçanetas"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_9"} defaultMessage={"Brinquedos"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_10"} defaultMessage={"Teclados de computador"}/></li>
                    <li>• <FormattedMessage id={"transmission_text_11"} defaultMessage={"etc..."}/></li>
                </ul>
            </div>
        </Row>

        <Row>
            <div align="center">
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

    </Card>

);

export default Sobre;